export const loadGoogleTagManager = (gtmId: string) => {
    if (document.getElementById('gtm-script')) return;

    // Create dataLayer if not already present
    (window as any).dataLayer = (window as any).dataLayer || [];

    // Push GTM start event
    (window as any).dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
    });

    // Create GTM script
    const script = document.createElement('script');
    script.id = 'gtm-script';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);
};
